var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor youtube-set-moderation-status" },
    [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("auto.youTubeSetModerationStatusChannelId"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "YouTube Channel ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.channelId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "channelId", $$v)
              },
              expression: "clone.channelId",
            },
          }),
          _vm._v(" "),
          _c("small", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "auto.youTubeSetModerationStatusModerasyonYapLacakYorumunBulunduUKanalIdsi"
                )
              )
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("auto.youTubeSetModerationStatusCommentId"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "YouTube Comment ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.commentId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "commentId", $$v)
              },
              expression: "clone.commentId",
            },
          }),
          _vm._v(" "),
          _c("small", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "auto.youTubeSetModerationStatusModerasyonDurumuDeITirilecekYorumunIdsi"
                )
              )
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              _vm._s(_vm.$t("auto.youTubeSetModerationStatusModerasyonDurumu"))
            ),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticClass: "classic-select",
              attrs: {
                placeholder: _vm.$t(
                  "auto.youTubeSetModerationStatusModerasyonDurumuSeIniz"
                ),
              },
              model: {
                value: _vm.clone.moderationStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "moderationStatus", $$v)
                },
                expression: "clone.moderationStatus",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "published" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("auto.youTubeSetModerationStatusYayNlaPublished")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "heldForReview" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "auto.youTubeSetModerationStatusNcelemeyeAlHeldforreview"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "rejected" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("auto.youTubeSetModerationStatusReddetRejected")
                  )
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              _vm._s(
                _vm.$t("auto.youTubeSetModerationStatusYorumSahibiniBanla")
              )
            ),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            model: {
              value: _vm.clone.banAuthor,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "banAuthor", $$v)
              },
              expression: "clone.banAuthor",
            },
          }),
          _vm._v(" "),
          _vm.clone.banAuthor
            ? _c("small", { staticClass: "ban-warning" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "auto.youTubeSetModerationStatusDikkatBuKullanCKanalNZdaBirDahaYorumYapamayacak"
                    )
                  )
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }